import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../../API';
import * as toast from '../../components/Toast'

export const getTableReservationConfigurationACTION = createAsyncThunk(
    'TableReservation/getconfiguration',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/getconfiguration", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);
export const InsertUpdateTableReservationACTION = createAsyncThunk(
    'TableReservation/insertupdate',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/insertupdate", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);

export const ValidateOtpReservationACTION = createAsyncThunk(
    'TableReservation/ValidateOtpReservation',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/validateotp", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);

export const ResendOtpReservationACTION = createAsyncThunk(
    'TableReservation/ResendOtpReservation',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/resendotp", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);

export const GetAllTableReservationACTION = createAsyncThunk(
    'TableReservation/GetAllTableReservation',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/getall", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);

export const GetTableReservationACTION = createAsyncThunk(
    'TableReservation/GetTableReservation',
    async (data) => {

        return API.apiCall("/restaurant/web/tablereservation/get", "POST", data, false)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (!response.data.hasError) {
                        // toast.success(response.data.message.message)
                        return {
                            ...response.data
                        }
                    } else {
                        toast.error(response.data.message.message)
                        return Promise.reject({
                            ...response.data.message
                        })
                    }
                }
            })
            .catch((error) => {
                return Promise.reject({
                    ...error
                })
            })
    }
);
